<template>
  <section>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    />
    <v-card class="p-0" v-if="persona">
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex shrink>
            <v-avatar
              :size="100"
              :color="persona.foto ? '#FFF' : 'light-blue darken-4'"
            >
              <img
                v-if="persona.foto"
                :src="url_backend + persona.foto"
                :alt="persona.nombres[0]"
                style="border: 1px solid #7BAFD4 !important;"
                @error="handleImageError()"
              />
              <span v-else class="white--text headline">{{
                persona.nombres[0] || "-"
              }}</span>
            </v-avatar>
          </v-flex>
          <v-flex grow class="text-xs-center">
            <b class="blue--text">NOMBRE: </b>{{ persona.ap_paterno }}
            {{ persona.ap_materno }} {{ persona.nombres }}
            <br />
            <b class="blue--text">NRO DOCUMENTO: </b>{{ persona.nro_doc }}
            <br />
            <b class="blue--text">ITEM: </b>{{ persona.movilidad.nro_item }}
            <br />
            <b class="blue--text">UNIDAD: </b
            >{{ persona.movilidad.nombre_unidad }}
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  components: {},
  mixins: [validate],
  props: ["id_persona"],
  data() {
    return {
      valid: false,
      form: {},
      loading: false,
      url_backend: process.env.API_URL.split("api/")[0],
      persona: null
    };
  },
  async created() {
    this.persona = await this.obtieneDatosPersona(this.id_persona);
  },
  async mounted() {},
  methods: {
    // Metodo para verificar si ocurrio un error al cargar la imagen
    handleImageError() {
      this.persona.foto = ''
    },
    // Metodo para obtener datos de la persona
    async obtieneDatosPersona(id_persona) {
      try {
        var persona = {};
        let res = await this.$service.graphql({
          query: `
            query{
              persona(id: ${id_persona}){
                id
                nombres
                ap_paterno
                ap_materno
                nro_doc
                foto
              }
            }
          `
        });
        persona = res.persona;
        // // Obtenemos datos de movilidad
        let query = `select vmasi.nro_item, u.nombre_unidad from movilidad.v_movilidad_activa_sin_interinato vmasi join movilidad.unidad u on u.id = vmasi.id_unidad  where vmasi.id_persona = ${id_persona}`;
        res = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"${query}"){
                respuesta
              }
            }
          `
        });
        let movilidad = res.runQuery.respuesta ? res.runQuery.respuesta[0] : {};
        persona.movilidad = movilidad;
        return persona;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.list-wrapper__dragarea {
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/tipificacion/components/DatosPersonales.vue